<template>
  <v-dialog v-model="dialog" :width="width" :persistent="true">
    <template #activator="{ on }" v-if="open_button">
      <v-btn color="primary" v-on="on" v-access="checkAccess()" :style="button_style">
        <slot name="button"></slot>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          <slot name="title"></slot>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <slot name="form" :resource="resource"></slot>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="action" :resource="resource"></slot>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" @click="store" :disabled="!valid || loading" :loading="loading">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {trans} from '../app';
import {ErrorsBag} from '../utils/ErrorsBag';
import {mapGetters} from 'vuex';

export default {
  props: {
    permission: {
      type: String,
      required: false,
    },
    model: Object,
    schema: Object,
    endpoint: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      required: true,
      validator: (value) => ['POST', 'PATCH', 'PUT'].includes(value),
    },
    width: {
      type: Number,
      default: 500
    },
    open_button: {
      type: Boolean,
      default: true
    },
  button_style: {
        required: false,
        type: Object,
        default() {
          return {};
        },
      }},
  data: () => ({
    loading: false,
    valid: false,
    dialog: false,
    resource: {},
  }),
  created() {
    this.errors = new ErrorsBag();
  },
  computed: {
    ...mapGetters(['hasPermission']),
  },
  methods: {
    setValue(field, value) {
      this.resource[field] = value;
    },
    resetForm() {
      setTimeout(() => {
        this.resetValidation();
        this.valid = true;
        this.resource = {};
      }, 100);
    },

    checkAccess() {
      if (this.permission) {
        return this.hasPermission(this.permission);
      }

      return true;
    },
    open() {
      this.resetValidation();
      this.dialog = true;
    },
    close() {
      this.dialog = false;

      this.resetForm();

      this.$emit('closed');
    },
    async store() {
      this.loading = true;
      if (!this.$refs.form.validate()) {
        this.loading = false;
        return;
      }
      try {
        const response = await axios({
          url: this.endpoint,
          method: this.method,
          data: this.resource,
        });

        this.$root.$emit('stored', {
          type: this.resource,
          response,
        });

        this.$toast(trans('app.saved'));
        this.close();

      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.errors.record(error.response.data.errors);
        } else {
          this.sentryCaptureException(error);
        }
      }
      this.loading = false;
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  },
  watch: {
    model(value) {
      if (value) {
        this.resource = {...this.schema, ...value};
        this.open();
      }
    },
    dialog(value) {
      if (value === false) {
        this.$emit('closed');
        this.resetForm();
      }
    }
  },
};
</script>
